import { Box, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import BrownNews from "../img/BrowNews_x600.png";
import WhiteNews from "../img/WhiteNews_x600.png";
import Farmer from "../img/SomeGuy_x600.png";

const useStyles = makeStyles((theme) => ({
  infoContainer: {
    padding: "20px",
    height: "auto",
    width: "100%",
  },
  borderBox: {
    width: "100%",
    height: "auto",
    padding: "10px",
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: "5px",
  },
  paper: {
    width: "100%",
    height: "auto",
    borderRadius: "5px",
    boxShadow: "2px 2px 10px 0 rgba(0,0,0, 0.2)",
    backgroundColor: "white",
    paddingTop: "75px",
    paddingLeft: "10px",
    paddingRight: "40px",
    paddingBottom: "10px",
    position: "relative",
    zIndex: 5,
    [theme.breakpoints.down("s")]: {
      paddingLeft: "10px",
      paddingRight: "10px",
    },
  },
  img: {
    marginBottom: "20px",
    zIndex: 100,
    width: "100%",
  },
  farmer: {
    position: "absolute",
    top: "-75px",
    right: 0,
    zIndex: -5,
  },
}));
export default function Info() {
  const classes = useStyles();
  return (
    <Box className={classes.infoContainer}>
      <Box className={classes.borderBox}>
        <Typography variant="h2" gutterBottom>
          今月の産直野菜
        </Typography>
        <Box className={classes.paper}>
          <img src={BrownNews} alt="brown" className={classes.img} />
          <img src={WhiteNews} alt="whte" className={classes.img} />
          <img src={Farmer} alt="farmer" className={classes.farmer} />
        </Box>
      </Box>
    </Box>
  );
}
